"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const gridHeight = {
    height: 'calc(100vh - 220px)'
};
const modalContainer = theme => ({
    padding: 24,
    width: 390,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalConfirmContainer = {
    padding: 10,
    paddingTop: 0,
    width: 432,
    height: 376,
};
const modalHeader = {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    alignItems: 'center',
    marginBottom: 24
};
const itemAdd = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20
};
const inputContainerItem = {
    width: 200
};
const inputItem = {
    height: 27,
    borderRadius: 5
};
const buttonSave = theme => ({
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: constants_1.color.white,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'light' ? constants_1.color.redDark : constants_1.color.buttonDark,
    height: 40,
    width: 84,
    borderRadius: 10,
});
const buttonDelete = {
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: constants_1.color.white,
    backgroundColor: constants_1.color.redDark,
    height: 35,
    width: 65,
    borderRadius: 10
};
const modalTitle = {
    margin: 0,
    fontSize: 20,
};
const dropdownStyle = theme => ({
    width: 200,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.borderGrey,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
exports.default = {
    gridHeight,
    dropdownStyle,
    modalContainer,
    modalTitle,
    modalHeader,
    itemAdd,
    inputContainerItem,
    inputItem,
    buttonSave,
    buttonDelete,
    modalConfirmContainer,
};
